module.exports = __webpack_public_path__ + "img/4k-wallpaper-android-wallpaper-astro-astrology-1146134.b3778cdd.jpg";